import type { OperationWithFormat, SignAsInfo, SignatoryFormData } from './SignatoryModal';

const PROXY_SIGN_AS = 'Procurador';

export interface SignatoryPayload {
    individualUuid?: string;
    position: string;
    allowedOperations: { operation: string; representationFormat: string }[];
    proxyExpirationDate?: string;
    proxyAllowedValue?: number;
}

const isProxyEntry = (entry: SignAsInfo): boolean => entry.signAs === PROXY_SIGN_AS;

const toAllowedOperation = (operation: OperationWithFormat) => ({
    operation: operation.operation,
    representationFormat: operation.representationFormat,
});

const toAllowedValue = (value: number | string | undefined): number | undefined => {
    if (value === undefined || value === '') return undefined;
    const parsed = typeof value === 'number' ? value : parseFloat(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return undefined;
    return parsed;
};

/**
 * True when the signatory signs as Procurador: only then the modal shows the proxy expiration date.
 */
export const isProxySigner = (signAsEntries: SignAsInfo[]): boolean => signAsEntries.some(isProxyEntry);

/**
 * Body of POST/PUT /legal-persons/{id}/signatories. The allowed value goes for every signatory
 * when it is a number above zero; empty, undefined and R$ 0,00 leave the key out (saved as null).
 */
export const buildSignatoryPayload = (form: SignatoryFormData): SignatoryPayload => {
    const payload: SignatoryPayload = {
        individualUuid: form.individualUuid,
        position: form.position,
        allowedOperations: form.operationsWithFormat.map(toAllowedOperation),
    };
    if (isProxySigner(form.signAsEntries) && form.proxyExpirationDate) payload.proxyExpirationDate = form.proxyExpirationDate;
    const allowedValue = toAllowedValue(form.proxyAllowedValue);
    if (allowedValue !== undefined) payload.proxyAllowedValue = allowedValue;
    return payload;
};
